<template>
  <div class="app-info-container d-flex flex-column gap-2">
    <div>
      {{ $t("global.appInfo.version") }}:
      <Tag :value="version" severity="secondary" icon="pi pi-cog"></Tag>
    </div>
    <div>
      {{ $t("global.appInfo.env") }}:
      <Tag :value="env" severity="success" icon="pi pi-warehouse"></Tag>
    </div>
  </div>
</template>

<script setup>
const version = import.meta.env.VITE_APP_VERSION
const env = import.meta.env.VITE_DD_ENV
</script>
